import { Box, MenuItem, Pagination, Select, Typography } from "@mui/material";
import PropTypes from "prop-types";

const PaginationComponent = ({ page, totalPages, rowsPerPage, setPage, setRowsPerPage }) => {
    return (
        <div className="flex text-xs lg:flex-row gap-3 flex-col items-center justify-between p-2 pt-2 pb-3">
            <Box
                display="flex"
                alignItems="center"
                sx={{ fontSize: '0.875rem', fontFamily: 'Poppins, sans-serif', padding: '5px', width: 'fit-content' }}
            >
                <Typography sx={{ color: "#717171", fontSize: '13px', marginRight: '0px', fontFamily: 'Poppins, sans-serif' }}>
                    Mostra
                </Typography>
                <Select
                    value={rowsPerPage}
                    onChange={(e) => {
                        setRowsPerPage(e.target.value);
                        setPage(1);
                    }}
                    sx={{
                        borderRadius: "6px",
                        borderColor: "#B8B8B8",
                        opacity: 1,
                        margin: "0 5px",
                        height: '30px',
                        fontSize: '13px',
                        fontFamily: 'Poppins, sans-serif',
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#B8B8B8',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#B8B8B8',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#B8B8B8',
                        },
                    }}
                >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                </Select>

                <Typography sx={{ fontSize: '0.875rem', fontFamily: 'Poppins, sans-serif' }}>
                    di {totalPages} risultati
                </Typography>
            </Box>

            <Pagination
                count={totalPages < rowsPerPage ? 1 : Math.ceil(totalPages / rowsPerPage)}
                page={page}
                onChange={(event, value) => setPage(value)}
                shape="rounded"
                size="small"
                siblingCount={0}
                boundaryCount={1}
                sx={{
                    "& .MuiPaginationItem-root": {
                        fontSize: "14px",
                        minWidth: "35px",
                        height: "35px",
                    },
                }}
            />
        </div>
    );
};
PaginationComponent.propTypes = {
    page: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    setPage: PropTypes.func.isRequired,
    setRowsPerPage: PropTypes.func.isRequired,
};

export default PaginationComponent;
